import { mapGetters } from 'vuex'
import { numberFormat } from '@/helpers'
import Collection from '@/core/Collection'

Vue.mixin({
    computed: {
        ...mapGetters({
            user: 'general/user'
        }),
        impersonatorOrUser() {
            return this.user.impersonator || this.user
        },
        locale() {
            return _.get(window, 'locale', 'cs')
        }
    },
    methods: {
        /**
         * Usage:
         * {{ moment().toDateString() }} => '2020-12-31'
         */
        moment(date) {
            return moment(_.get(date, 'date', date))
        },
        /**
         * Usage:
         * {{ toDate(date) }} => '23.01. 1998'
         */
        // TODO: Conflict with v-calendar in app/reporting/
        // toDate(date) {
        //   return moment(_.get(date, 'date', date)).format('DD.MM. YYYY')
        // },
        /**
         * Usage:
         * {{ toDay(date) }} => '[1p] Monday'
         */
        toDay(date) {
            return moment(_.get(date, 'date', date)).format('dddd')
        },
        /**
         * Usage:
         * {{ toTime(date) }} => '03:15'
         */
        toTime(date) {
            return moment(_.get(date, 'date', date)).format('LT')
        },
        /**
         * Usage:
         * {{ toTimeRange(start, end) }} => '12:00 - 23:59'
         */
        toTimeRange(start, end) {
            const timeRange = [this.toTime(start), this.toTime(end)]

            return timeRange.join(' - ')
        },
        /**
         * Usage:
         * {{ collect() }} => new Collection instance
         */
        collect(data, options) {
            return new Collection(data, options)
        },
        /**
         * Usage:
         * {{ __('Hello') }} => 'Ahoj'
         */
        __(key, params = {}) {
            return window.lang.get(key, params)
        },
        /**
         * Usage:
         * {{ __choice('[1] 1 person|[2,*] :people people', 1, { people: 1 }) }} => '1 person'
         * {{ __choice('[1] 1 person|[2,*] :people people', 2, { people: 2 }) }} => '2 people'
         */
        __choice(key, count, params = {}) {
            return window.lang.choice(key, count, params)
        },
        // format number
        numberFormat(amount, decimalCount = 2, decimal = ',', thousands = ' ') {
            return numberFormat(amount, decimalCount, decimal, thousands)
        },
        monthNameDeclension(month) {
            month = month - 1
            const months = ['[2p] January', '[2p] February', '[2p] March', '[2p] April', '[2p] May', '[2p] June', '[2p] July', '[2p] August', '[2p] September', '[2p] October', '[2p] November', '[2p] December']

            return lang.get(months[month])
        },
        getPhoneCountryNumber(country) {
            if (country === 'DE') {
                return '+49'
            }

            if (country === 'CZ') {
                return '+420'
            }

            if (country === 'SK') {
                return '+421'
            }
        },
        impersonatingAsSubstitute() {
            return window.User.is_impersonating && window.User.is_substitute
        }
    }
})
